export default function (prismicContent) {
  //
  const returnLanguages = {};
  // Get the current locale & uid
  const { lang, uid } = prismicContent;
  // Check lang
  if (!lang) {
    return returnLanguages
  }
  // Prismic lang to i18n locale
  const locale = lang.substring(0, 2);
  //returnLanguages[locale] = { slug: uid };
  // Get alternative languages
  const languages = prismicContent.alternate_languages;
  // Get the land and uid for each alternative language
  languages.map((l) => {
    returnLanguages[l.lang.substring(0, 2)] = { slug: l.uid };
  });
  // Return the i18n params
  return returnLanguages;
}
